var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAux1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 12,
    viewBox: "0 0 31 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63991 11H0.333097L3.84801 0.818182H6.62216L10.1321 11H7.82528L5.27486 3.14489H5.19531L2.63991 11ZM2.49574 6.99787H7.9446V8.67827H2.49574V6.99787ZM17.6467 0.818182H19.7994V7.4304C19.7994 8.17282 19.622 8.82244 19.2674 9.37926C18.9161 9.93608 18.4239 10.3703 17.7908 10.6818C17.1578 10.9901 16.4203 11.1442 15.5785 11.1442C14.7333 11.1442 13.9942 10.9901 13.3612 10.6818C12.7281 10.3703 12.2359 9.93608 11.8846 9.37926C11.5333 8.82244 11.3576 8.17282 11.3576 7.4304V0.818182H13.5103V7.24645C13.5103 7.63423 13.5948 7.97893 13.7638 8.28054C13.9362 8.58215 14.1781 8.81913 14.4897 8.99148C14.8013 9.16383 15.1642 9.25 15.5785 9.25C15.9961 9.25 16.359 9.16383 16.6673 8.99148C16.9788 8.81913 17.2191 8.58215 17.3881 8.28054C17.5605 7.97893 17.6467 7.63423 17.6467 7.24645V0.818182ZM23.589 0.818182L25.6422 4.28835H25.7218L27.785 0.818182H30.2161L27.1088 5.90909L30.2857 11H27.8098L25.7218 7.52486H25.6422L23.5542 11H21.0882L24.275 5.90909L21.1479 0.818182H23.589Z",
    fill: "#002E6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAux1);
export default __webpack_public_path__ + "static/media/aux1.9a7f28a1182ef4f06ad5a45f68203503.svg";
export { ForwardRef as ReactComponent };